/**
 * Service to fetch configuration from the backend.
 */
class ConfigService {
    static async getSentryConfig() {
        try {
            // Determine API URL (assuming relative or from environment)
            const baseUrl = process.env.REACT_APP_API_URL || '';
            const response = await fetch(`${baseUrl}/api/integrations/config/sentry/`);

            if (!response.ok) {
                throw new Error(`Failed to fetch Sentry config: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching Sentry configuration:", error);
            return null;
        }
    }
}

export default ConfigService;
